import type * as React from "react"

import type { Sidebar } from "@/components/ui/sidebar"

import { AppSidebar } from "@/components/layouts/app-layout/app-sidebar"

import { TrainingNavMain } from "./training-nav-main"

export function TrainingSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <AppSidebar {...props}>
      <TrainingNavMain />
    </AppSidebar>
  )
}
